import { Component, Input, OnInit, TemplateRef, ViewChild } from '@angular/core';
import { BsModalRef, BsModalService } from 'ngx-bootstrap/modal';
import { ICountry, IState } from '../interface';
import { GeneralService } from 'src/app/services/general.service';
import { ModalWrapperService } from 'src/app/services/modal-wrapper.service';


@Component({
    selector: 'app-business-military-popup',
    templateUrl: './business-military-popup.component.html',
    styleUrls: ['./business-military-popup.component.scss'],
    standalone: false
})
export class BusinessMilitaryPopupComponent implements OnInit {
  @Input() customerInfoDetails;
  modalRef: BsModalRef;
  @Input() countrySelectedMilitary;
  @Input() stateSelectedMilitary;
  @Input() EmailId;
  @Input() countryDetailsBusiness;
  @Input() stateDetailsBusiness;
  @ViewChild('BusinessDisable', { static: true }) BusinessDisable: TemplateRef<any>;
  @ViewChild('MilitaryDisable', { static: true }) MilitaryDisable: TemplateRef<any>;
  countryList: ICountry[];
  stateList: IState[];
  constructor(public modalWrapper: ModalWrapperService,
    public generalService: GeneralService,
  ) { }

  ngOnInit(): void {
    this.getCountries();
    this.getAllStates();
  }

  getCountries() {
    this.generalService.getCountries().subscribe((response: ICountry[]) => {
      if (response.length != 0) {
        this.countryList = response;
      }
    });
  }

  getAllStates() {
    this.generalService.getAllStates().subscribe((resp: IState[]) => {
      this.stateList = resp;
    });
  }

  OpenModal(calledFrom) {
    if (calledFrom == 1) {
      this.modalRef = this.modalWrapper.openTemplate(this.BusinessDisable, {
        class: 'modal-dialog modal-lg modal-dialog-centered', backdrop: 'static',
        keyboard: false
      });
    }
    else {
      this.modalRef = this.modalWrapper.openTemplate(this.MilitaryDisable, {
        class: 'modal-dialog modal-lg modal-dialog-centered', backdrop: 'static',
        keyboard: false
      });
    }
    this.customerInfoDetails.MilitaryIdExpDate = this.customerInfoDetails.Military && this.customerInfoDetails.MilitaryIdExpDate ? this.customerInfoDetails.MilitaryIdExpDate.replace('Z','') : '';
    this.customerInfoDetails.MilitaryDeploymentDate = this.customerInfoDetails.Military && this.customerInfoDetails.MilitaryDeploymentDate ? this.customerInfoDetails.MilitaryDeploymentDate.replace('Z', '') : '';
    this.countryDetailsBusiness = this.countryDetailsBusiness ? this.countryDetailsBusiness : this.customerInfoDetails.CompanyCountryId ? this.countryList.find(x => x.Id == this.customerInfoDetails.CompanyCountryId).Name : "";
    this.countrySelectedMilitary = this.countrySelectedMilitary ? this.countrySelectedMilitary : this.customerInfoDetails.COICountryId ? this.countryList.find(x => x.Id == this.customerInfoDetails.COICountryId).Name : "";
    this.stateSelectedMilitary = this.stateSelectedMilitary ? this.stateSelectedMilitary : this.customerInfoDetails.COIState ? this.stateList.find(x => x.Id == this.customerInfoDetails.COIState).Name : "";
    this.stateDetailsBusiness = this.stateDetailsBusiness ? this.stateDetailsBusiness : this.customerInfoDetails.CompanyState ? this.stateList.find(x => x.Id == this.customerInfoDetails.CompanyState).Name : "";
  }
}
